import { render, staticRenderFns } from "./HotProductList.vue?vue&type=template&id=023f81c7&scoped=true&"
import script from "./HotProductList.vue?vue&type=script&lang=js&"
export * from "./HotProductList.vue?vue&type=script&lang=js&"
import style0 from "./HotProductList.vue?vue&type=style&index=0&id=023f81c7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "023f81c7",
  null
  
)

export default component.exports